import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(private titleService: Title) { }
 
   ngOnInit() {
      this.titleService.setTitle('Home SolarCiti');
   }
 


  blogs = [

    {
        id: 1,
        category: 'Solar Guide',
        date: 'August 18, 2026',

        title: 'How Does a Rooftop Solar System Work?',

        shortDescription:
            'Understand how solar panels generate electricity and how solar power can be used for your home or business.',

        image: 'assets/image/home.png',

        // detail content...
    },

    {
        id: 2,
        category: 'Solar Systems',
        date: 'August 15, 2026',

        title:
            'On-Grid, Off-Grid or Hybrid: Which Solar System Is Right for You?',

        shortDescription:
            'Compare different solar system types and understand which solution may suit your energy requirements.',

        image: 'assets/image/about-1.png',

        // detail content...
    },

    {
        id: 3,
        category: 'Solar Savings',
        date: 'August 12, 2026',

        title:
            'What Should You Consider Before Installing Solar?',

        shortDescription:
            'Learn about electricity usage, rooftop space, system sizing, installation, and other important factors before going solar.',

        image: 'assets/image/home2.png',

        // detail content...
    }

];
}
